import React, { Fragment, memo } from 'react'
import Hidden from '@material-ui/core/Hidden'
import LOG from '../../logging/Logger'

export default memo(() => {
  LOG.debug('Render: ScreenWidth')

  return (
    <Fragment>
      <Hidden only={['sm', 'md', 'lg', 'xl']}>xs</Hidden>
      <Hidden only={['xs', 'md', 'lg', 'xl']}>sm</Hidden>
      <Hidden only={['xs', 'sm', 'lg', 'xl']}>md</Hidden>
      <Hidden only={['xs', 'sm', 'md', 'xl']}>lg</Hidden>
      <Hidden only={['xs', 'sm', 'md', 'lg']}>xl</Hidden>
    </Fragment>
  )
})
